require('./bootstrap.js');

import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import Notifications from 'vue-notification';
import Nl2br from 'vue-nl2br';
import VueCkeditor from 'vue-ckeditor2';

import App from '@/Expert.vue';
import router from '@/router/expert';
import '@/scss/expert.scss';
import '@/config/expert/http';
import Vuex from 'vuex';
import loader from './store/loader';
import '@/util/mixin';

Vue.use(BootstrapVue);
Vue.use(Notifications);
Vue.component('nl2br', Nl2br);
Vue.component('vue-ckeditor', VueCkeditor);

Vue.use(Vuex);
const store = new Vuex.Store({
    modules: {
        loader,
    }
});

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: {
        App
    },
    mounted() {
        let recaptchaScript = document.createElement('script');
        recaptchaScript.setAttribute('src', 'https://cdn.ckeditor.com/4.10.0/standard/ckeditor.js');
        document.head.appendChild(recaptchaScript);
    },
    store,
    template: '<App/>'
});
